import React from 'react';
import PropTypes from 'prop-types';

function NutritionPanelDisclaimer({ disclaimer, className }) {
  if (!disclaimer) {
    return null;
  }

  return <div className={className}>{disclaimer}</div>;
}

NutritionPanelDisclaimer.propTypes = {
  disclaimer: PropTypes.string,
  className: PropTypes.string,
};

NutritionPanelDisclaimer.defaultProps = {
  disclaimer: null,
  className: 'border border-dark p-2 mb-2',
};

export default NutritionPanelDisclaimer;
